<form [formGroup]="setupContextForm" (ngSubmit)="onSubmit()">

  @let templates = templatesRes.value();

  <div class="bg-white p-4 rounded-3" style="overflow: auto;">

    <h4 class="text-primary mb-4">Obiettivo e punti di attenzione</h4>

    <div class="row mb-4">
      <div class="col-md-12">
        <label for="mainGoal" class="form-label" i18n>Qual è l'obiettivo principale di questo motore di
          ricerca?</label>
        <app-field-loader [loading]="setupLoading()">
          <input type="text" class="form-control" id="mainGoal"
            placeholder="Es. Dovrai dare informazioni su alcune offerte di Marketing." formControlName="mainGoal" />
        </app-field-loader>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-12">
        <label for="focusItems" class="form-label" i18n>Quali sono i punti di attenzione che vale la pena
          evidenziare?</label>
        <app-field-loader [loading]="setupLoading()">
          <input type="text" class="form-control" id="focusItems"
            placeholder="Es. Fai molta attenzione a non confondere le offerte tra loro." formControlName="focusItems" />
        </app-field-loader>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-12">
        <label for="additionalInstructions" class="form-label">Istruzioni aggiuntive</label>
        <app-field-loader [loading]="setupLoading()">
          <input type="text" class="form-control" id="additionalInstructions"
            placeholder="Es. utilizza al massimo due frasi nella risposta" formControlName="additionalInstructions" />
        </app-field-loader>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-6">
        <label for="topResults" class="form-label">
          Numero di risultati da considerare per generare la risposta
        </label>
        <app-field-loader [loading]="setupLoading()" offset="me-5">
          <input type="number" class="form-control" id="topResults" formControlName="topResults" min="1" max="10"
            step="1" [class.is-invalid]="topResults?.touched && topResults?.invalid" />
        </app-field-loader>
        @if (topResults?.touched && topResults?.invalid) {
        <div class="text-danger">
          Deve essere un numero intero.
        </div>
        }
      </div>

      <div class="col-md-6">
        <label for="ignoreLowRelevant" class="form-label">
          Ignora risultati poco rilevanti
        </label>
        <app-field-loader [loading]="setupLoading()" offset="me-5">
          <select class="form-select" id="ignoreLowRelevant" formControlName="ignoreLowRelevant">
            <option [ngValue]="false">No</option>
            <option [ngValue]="true">Sì</option>
          </select>
        </app-field-loader>
      </div>
    </div>

    <h4 class="text-primary mb-4">Stile e comportamento della risposta</h4>

    <div class="row mb-4">
      <div class="col-md-8">
        <label for="templateAccuracy" class="form-label" i18n>Attendibilità delle risposte</label>
        <app-field-loader [loading]="templatesLoading()" offset="me-5">
          <select class="form-select" id="templateAccuracy" formControlName="accuracy">
            <option [ngValue]="null" selected>Automatico</option>
            @for (template of templates?.ACCURACY ?? []; track $index) {
            <option [ngValue]="template.preamble">{{ template.description }}</option>
            }
          </select>
        </app-field-loader>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-8">
        <label for="templateLength" class="form-label" i18n>Quanto deve essere lunga la risposta?</label>
        <app-field-loader [loading]="templatesLoading()" offset="me-5">
          <select class="form-select" id="templateLength" formControlName="answerLength">
            <option [ngValue]="null" selected>Automatico</option>
            @for (template of templates?.LENGTH ?? []; track $index) {
            <option [ngValue]="template.preamble">{{ template.description }}</option>
            }
          </select>
        </app-field-loader>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-8">
        <label for="templateTone" class="form-label" i18n>Quale tono di voce deve essere utilizzato?</label>
        <app-field-loader [loading]="templatesLoading()" offset="me-5">
          <select class="form-select" id="templateTone" formControlName="toneOfVoice">
            <option [ngValue]="null" selected>Automatico</option>
            @for (template of templates?.TONE_OF_VOICE ?? []; track $index) {
            <option [ngValue]="template.preamble">{{ template.description }}</option>
            }
          </select>
        </app-field-loader>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-8">
        <label for="templateFormat" class="form-label" i18n>Quale formato deve avere la risposta?</label>
        <app-field-loader [loading]="templatesLoading()" offset="me-5">
          <select class="form-select" id="templateFormat" formControlName="format">
            <option [ngValue]="null" selected>Automatico</option>
            @for (template of templates?.FORMAT ?? []; track $index) {
            <option [ngValue]="template.preamble">{{ template.description }}</option>
            }
          </select>
        </app-field-loader>
      </div>
    </div>

    <h4 class="text-primary mb-4">Impostazioni del modello</h4>

    <div class="row mb-4">
      <div class="col-md-8">
        <label for="summarizationModel" class="form-label">Modello</label>
        <app-field-loader [loading]="modelsLoading()" offset="me-5">
          <select class="form-select" id="summarizationModel" formControlName="summarizationModel">
            <option [ngValue]="null" disabled selected>Seleziona un modello</option>
            @for (model of modelsRes.value() ?? []; track $index) {
            <option [ngValue]="model.model">{{ model.description }}</option>
            }
          </select>
        </app-field-loader>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-8">
        <label for="languageCode" class="form-label">Lingua</label>
        <app-field-loader [loading]="languagesLoading()" offset="me-5">
          <select class="form-select" id="languageCode" formControlName="languageCode">
            <option [ngValue]="null">Riconoscimento automatico</option>
            @for (language of languagesRes.value() ?? []; track $index) {
            <option [ngValue]="language.code">{{ language.name }}</option>
            }
          </select>
        </app-field-loader>
        <div id="languageCodeHelp" class="form-text">
          Se non specificato, la lingua viene riconosciuta automaticamente.
        </div>
      </div>
    </div>

    <div *ngxPermissionsOnly="['ROLE_MAD']">

      <h4 class="text-primary mb-4">Integrazione API</h4>

      <div class="row mb-4">
        <div class="col-md-8">
          <label for="integrationStatus" class="form-label">Stato dell'integrazione</label>
          <app-field-loader [loading]="setupLoading()" offset="me-5">
            <select class="form-select" id="integrationStatus" formControlName="integrationStatus">
              <option [ngValue]="'BACKEND_INTEGRATION_ONLY'" selected>Solo integrazione backend</option>
              <option [ngValue]="'FRONTEND_INTEGRATION_ALLOWED'">Integrazione frontend</option>
              <option [ngValue]="'DISABLED'">Disabilitata</option>
            </select>
          </app-field-loader>
        </div>
      </div>

      @if (setupContextForm.get('integrationStatus')?.value === 'FRONTEND_INTEGRATION_ALLOWED') {
      <div class="row mb-4">
        <div class="col-md-8">
          <label for="allowedDomains" class="form-label">Domini abilitati</label>
          <app-field-loader [loading]="domainsLoading()">
            <textarea class="form-control" id="allowedDomains" rows="3" formControlName="allowedDomains"
              placeholder="Inserisci i domini separati da una virgola."></textarea>
          </app-field-loader>
          <div id="allowedDomainsHelp" class="form-text">
            Inserisci i domini separati da una virgola. Ad esempio: example.com, example.org
          </div>
        </div>
      </div>
      }
    </div>

  </div>

  @if (setupContextForm.dirty) {
  <div class="alert alert-warning mt-3" role="alert" i18n>
    Attenzione: hai apportato delle modifiche alla configurazione del contesto. Se vuoi renderle effettive
    assicurati di salvarle prima di lasciare questa pagina, altrimenti andranno perse.
  </div>
  }

  <div class="d-flex justify-content-end mt-3">
    <app-loading-button class="me-2" type="button" [loading]="deleteLoading()"
      [disabled]="deleteLoading() || contextDetail().isLoading()" buttonType="danger" i18n
      *ngxPermissionsOnly="['ROLE_MAD']" (clickButton)="deleteContext()">
      Elimina Contesto
    </app-loading-button>

    <app-loading-button class="me-2" type="button" buttonType="secondary" [loading]="previewLoading()"
      [disabled]="setupContextForm.invalid || previewLoading() || anyLoading()" (clickButton)="openPreview()" i18n>
      Mostra Preview
    </app-loading-button>

    <app-loading-button [loading]="loading()"
      [disabled]="setupContextForm.pristine || setupContextForm.invalid || loading() || anyLoading()" i18n>
      Aggiorna Configurazione
    </app-loading-button>
  </div>

</form>